import React from 'react'

export const UserHeaderIcon = () => (
  <svg
    className="signin-link-button"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 8C16 10.2091 14.2091 12 12 12C9.79086 12 8 10.2091 8 8C8 5.79086 9.79086 4 12 4C14.2091 4 16 5.79086 16 8Z"
      stroke="var(--color-main)"
      strokeWidth="1.5"
    />
    <path
      d="M17.5 20H6.5C6.22386 20 6 19.8271 6 19.551V18C6 15.6 8 14 10 14H14C17 14 18 17 18 18V19.5C18 19.7761 17.7761 20 17.5 20Z"
      stroke="var(--color-main)"
      strokeWidth="1.5"
    />
  </svg>
)
